import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Edit } from "react-feather";
// import { useSelector } from "react-redux";
import Table from "../../../core/pagination/datatable";
import TooltipIcons from "../../common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../common/tooltip-content/refresh";
import CollapesIcon from "../../common/tooltip-content/collapes";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import {
  createStore,
  getStores,
  updateStore,
  deleteStore,
} from "../../../api/storeApi"; // Adjust the import path as necessary
import { toast } from "react-toastify";

const StoreList = () => {
  // const data = useSelector((state) => state.rootReducer.customerdata);
  const [storeData, setStoreData] = useState([]);
  const [storeToDelete, setStoreToDelete] = useState(null);

  // Create new state
  const [storeNameEN, setStoreNameEN] = useState("");
  const [storeNameAR, setStoreNameAR] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [countryEN, setCountryEN] = useState("");
  const [countryAR, setCountryAR] = useState("");
  const [status, setStatus] = useState(true);

  // Edit state
  const [editingStoreId, setEditingStoreId] = useState(null);
  const [editStoreNameEN, setEditStoreNameEN] = useState("");
  const [editStoreNameAR, setEditStoreNameAR] = useState("");
  const [editUserName, setEditUserName] = useState("");
  const [editPassword, setEditPassword] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editPhone, setEditPhone] = useState("");
  const [editCountryEN, setEditCountryEN] = useState("");
  const [editCountryAR, setEditCountryAR] = useState("");
  const [editStatus, setEditStatus] = useState(true);

  const handleCreateStore = async (e) => {
    e.preventDefault();
    if (
      !storeNameEN ||
      !storeNameAR ||
      !userName ||
      !password ||
      !email ||
      !phone ||
      !countryEN ||
      !countryAR
    ) {
      toast.error(`❌ ${window.translate("Please fill all required fields")}`);
      return;
    }

    const payload = {
      storeName: { en: storeNameEN, ar: storeNameAR },
      userName,
      password,
      email,
      phone,
      country: { en: countryEN, ar: countryAR },
      status,
    };

    try {
      await createStore(payload);
      // toast.success("✅ Store created successfully");
      toast.success(` ${window.translate("Store created successfully")}`)
      // optionally refresh table or close modal
      // Optional: refresh supplier list or close modal
      document.getElementById("close-add-stock-btn")?.click();

      // Reload after short delay
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const data = await getStores(); // your API function
        setStoreData(data); // now matches table expectations
      } catch (err) {
        console.error(err);
      }
    };

    fetchStores();
  }, []);

  const handleUpdateStore = async (e) => {
    e.preventDefault();

    if (
      !editStoreNameEN ||
      !editStoreNameAR ||
      !editUserName ||
      !editEmail ||
      !editPhone ||
      !editCountryEN ||
      !editCountryAR
    ) {
      toast.error(`❌ ${window.translate("Please fill all required fields")}`);
      return;
    }

    const payload = {
      storeName: { en: editStoreNameEN, ar: editStoreNameAR },
      userName: editUserName,
      password: editPassword, // backend hashes only if provided
      email: editEmail,
      phone: editPhone,
      country: { en: editCountryEN, ar: editCountryAR },
      status: editStatus,
    };

    try {
      await updateStore(editingStoreId, payload);
      // toast.success("✅ Store updated successfully");
      toast.success(` ${window.translate("Store updated successfully")}`)
      // Optionally refetch store list
      // Optional: refresh supplier list or close modal
      document.getElementById("close-add-stock-btn")?.click();

      // Reload after short delay
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (err) {
      toast.error(`❌ ${window.translate("Failed to update store")}`);
      console.error(err);
    }
  };

  const handleDeleteStore = async () => {
    if (!storeToDelete) return;
    try {
      await deleteStore(storeToDelete);
      // toast.success("✅ Store deleted successfully");
      toast.success(` ${window.translate("Store deleted successfully")}`)

      // Update UI
      setStoreData((prev) =>
        prev.filter((store) => store.id !== storeToDelete)
      );
      setStoreToDelete(null);
      // Optional: refresh supplier list or close modal
      document.getElementById("close-add-stock-btn")?.click();

      // Reload after short delay
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (error) {
      toast.error(`❌ ${window.translate("Failed to delete store")}`);
    }
  };

  const columns = [
    {
      title: window.translate("Store Name"),
      dataIndex: "CustomerName",
      sorter: (a, b) => a.CustomerName.length - b.CustomerName.length,
    },

    {
      title: window.translate("Store"),
      dataIndex: "Customer",
      sorter: (a, b) => a.Customer.length - b.Customer.length,
    },

    {
      title: window.translate("Email"),
      dataIndex: "Email",
      sorter: (a, b) => a.Email.length - b.Email.length,
    },

    {
      title: window.translate("Phone"),
      dataIndex: "Phone",
      sorter: (a, b) => a.Phone.length - b.Phone.length,
    },

    {
      title: window.translate("Country"),
      dataIndex: "Country",
      sorter: (a, b) => a.Country.length - b.Country.length,
    },
    {
      title: window.translate("Status"),
      dataIndex: "status",
      render: (status) => (
        <span
          className={`badge fw-medium fs-10 ${
            status === "Active" ? "bg-success" : "bg-danger"
          }`}
        >
          {status}
        </span>
      ),
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: window.translate("Action"),
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>

            {/* <Link className="me-2 p-2" to="#">
              <Eye className="feather-view" />
            </Link> */}

            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#edit-store"
              onClick={() => {
                setEditingStoreId(record.id);
                setEditStoreNameEN(record.CustomerName);
                setEditStoreNameAR(record.CustomerName); // if Arabic not shown in table, store separately
                setEditUserName(record.Customer);
                setEditEmail(record.Email);
                setEditPhone(record.Phone);
                setEditCountryEN(record.Country);
                setEditCountryAR(record.Country); // same as above
                setEditStatus(record.status === "Active");
              }}
            >
              <Edit className="feather-edit" />
            </Link>

            <Link
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              className="p-2 d-flex align-items-center border rounded"
              to="#"
              onClick={() => setStoreToDelete(record.id)}
            >
              <i data-feather="trash-2" className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
      sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>{window.translate("Stores")}</h4>
                <h6>{window.translate("Manage your Store")}</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#add-store"
                className="btn btn-primary"
              >
                <PlusCircle data-feather="plus-circle" className=" me-2 ms-2" />
                {window.translate("Add Store")}
              </Link>
            </div>
          </div>

          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    {window.translate("Select")} {window.translate("status")}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {window.translate("active")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        In{window.translate("active")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        New Joiners
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body pb-0">
              <div className=" table-responsive">
                {storeData.length > 0 ? (
                  <Table columns={columns} dataSource={storeData} />
                ) : (
                  <p className="text-center mt-3 mb-3">
                    {window.translate("No store data available")}.
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* /product list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">{window.translate("2024-2025 © Hamilton POS. All Right Reserved")}</p>
          <p>
            {window.translate("Designed & Developed By")}
            <Link to="#" className="text-primary">
              {window.translate("Hamilton")}
            </Link>
          </p>
        </div>
      </div>
      <>
        {/* Add Store */}
        <div className="modal fade" id="add-store">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="page-title">
                  <h4>{window.translate("Add Store")}</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <form onSubmit={handleCreateStore}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Store Name")} (EN)<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={storeNameEN}
                      onChange={(e) => setStoreNameEN(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Store Name")} (AR)<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={storeNameAR}
                      onChange={(e) => setStoreNameAR(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("User Name")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>

                  <div className="input-blocks mb-3">
                    <label className="form-label">
                      {window.translate("Password")} <span className="text-danger">*</span>
                    </label>
                    <div className="pass-group">
                      <input
                        type="password"
                        className="form-control pass-input"
                        style={{paddingRight:"40px"}}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <span className="fas toggle-password fa-eye-slash" />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Email")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Phone")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Country")} (EN)<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={countryEN}
                      onChange={(e) => setCountryEN(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Country")} (AR)<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={countryAR}
                      onChange={(e) => setCountryAR(e.target.value)}
                    />
                  </div>
                  <div className="mb-0">
                    <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                      <span className="status-label ">{window.translate("Status")}</span>
                      <input
                        type="checkbox"
                        id="user2"
                        className="check"
                        checked={status}
                        onChange={(e) => setStatus(e.target.checked)}
                      />
                      <label htmlFor="user2" className="checktoggle" />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    data-bs-dismiss="modal"
                  >
                    {window.translate("Cancel")}
                  </button>
                  <button
                    type="submit"
                    data-bs-dismiss="modal"
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                  >
                    {window.translate("Add Store")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add Store */}
        {/* Edit Store */}
        <div className="modal fade" id="edit-store">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="page-title">
                  <h4>{window.translate("Edit Store")}</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <form onSubmit={handleUpdateStore}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Store Name")} (EN)<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={editStoreNameEN}
                      onChange={(e) => setEditStoreNameEN(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Store Name")} (AR)<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={editStoreNameAR}
                      onChange={(e) => setEditStoreNameAR(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("User Name")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={editUserName}
                      onChange={(e) => setEditUserName(e.target.value)}
                    />
                  </div>
                  <div className="input-blocks mb-3">
                    <label className="form-label">
                      {window.translate("Password")} <span className="text-danger">*</span>
                    </label>
                    <div className="pass-group">
                      <input
                        type="password"
                        className="form-control pass-input"
                        style={{paddingRight:"40px"}}
                        value={editPassword}
                        onChange={(e) => setEditPassword(e.target.value)}
                      />
                      <span className="fas toggle-password fa-eye-slash" />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Email")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      value={editEmail}
                      onChange={(e) => setEditEmail(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Phone")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={editPhone}
                      onChange={(e) => setEditPhone(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Country")} (EN) <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={editCountryEN}
                      onChange={(e) => setEditCountryEN(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {window.translate("Country")} (AR) <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={editCountryAR}
                      onChange={(e) => setEditCountryAR(e.target.value)}
                    />
                  </div>
                  <div className="mb-0">
                    <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                      <span className="status-label ">{window.translate("Status")}</span>
                      <input
                        type="checkbox"
                        id="user1"
                        className="check"
                        checked={editStatus}
                        onChange={(e) => setEditStatus(e.target.checked)}
                      />
                      <label htmlFor="user1" className="checktoggle" />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    data-bs-dismiss="modal"
                  >
                    {window.translate("Cancel")}
                  </button>
                  <button
                    type="submit"
                    data-bs-dismiss="modal"
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                  >
                     {window.translate("save Changes")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Store */}
      </>

      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content p-5 px-3 text-center">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger" />
                </span>
                <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">
                   {window.translate("Delete")}
                </h4>
                <p className="text-gray-6 mb-0 fs-16">
                  {window.translate("Are you sure you want to delete store")} 
                </p>
                <div className="modal-footer-btn mt-3 d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    data-bs-dismiss="modal"
                  >
                     {window.translate("Cancel")}
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-submit fs-13 fw-medium p-2 px-3"
                    onClick={handleDeleteStore}
                  >
                    {window.translate("Yes Delete")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreList;
